import script from "./OtherOperatingRevenue.vue?vue&type=script&setup=true&lang=js"
export * from "./OtherOperatingRevenue.vue?vue&type=script&setup=true&lang=js"

import "./OtherOperatingRevenue.vue?vue&type=style&index=0&id=116b3d5e&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-116b3d5e"]])

export default __exports__